import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export type PanelSettingsDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  proxyUrl: string;
  onProxyUrlChange: (value: string) => void;
  saving: boolean;
  onSave: () => void;
};

export function PanelSettingsDialog({
  open,
  onOpenChange,
  proxyUrl,
  onProxyUrlChange,
  saving,
  onSave,
}: PanelSettingsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Настройки панели</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Label htmlFor="ai-proxy-url">Прокси для AI-авторизации</Label>
          <Input
            id="ai-proxy-url"
            value={proxyUrl}
            onChange={(event) => onProxyUrlChange(event.target.value)}
            placeholder="http://user:password@host:port"
            type="url"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Отмена
          </Button>
          <Button onClick={onSave} disabled={saving}>
            {saving ? "Сохранение…" : "Сохранить"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
